import Encoding from 'encoding-japanese';

// API の NoSymbolsOrEmojisCase と同じ文字の範囲にする。範囲がずれると、画面ではエラーが出ないのに API で弾かれて登録できなくなるため。
// 空欄は「未入力」として残りの個数で扱うので、ここではエラーにしない（`*`）。
const ALLOWED_PATTERN = /^[ぁ-んァ-ヶー々a-zA-Zａ-ｚＡ-Ｚ0-9０-９ 　\t\r\n一-鿿豈-﫿]*$/u;

// 宛名は管理画面の名入れCSVで Shift_JIS（CP932）に変換される。CP932 に無い漢字は「?」に化けるため、同じ変換で元に戻るかを確かめる。
const isRepresentableInCsvEncoding = (value: string): boolean => {
  const sjisCodes = Encoding.convert(Encoding.stringToCode(value), { to: 'SJIS', from: 'UNICODE' });
  const decoded = Encoding.codeToString(Encoding.convert(sjisCodes, { to: 'UNICODE', from: 'SJIS' }));
  return decoded === value;
};

// CP932 には半角カタカナや記号も入っているため、往復変換だけでは判定せず、先に文字の種類を絞る
export const isValidOptionNameValue = (value: string): boolean => {
  if (!ALLOWED_PATTERN.test(value)) return false;
  return isRepresentableInCsvEncoding(value);
};
